export enum Classification {
	AMOUNT = 'AMOUNT',
	PERCENT = 'PERCENT',
}